const optionRelationship = [
	{ value: "Aunt", label: "Aunt" },
	{ value: "Uncle", label: "Uncle" },
	{ value: "Sibling", label: "Sibling" },
	{ value: "Parent", label: "Parent" },
	{ value: "Grandparent", label: "Grandparent" },
	{ value: "Others", label: "Others" },
];
export default optionRelationship;
